import React, { useEffect, useCallback } from 'react';
import { toast } from 'react-toastify';

import { Typography } from '@material-ui/core';
import { isArray, assign } from 'lodash';
import PropTypes from 'prop-types';

import { t } from '~/helpers';
import api from '~/services/api';

export default function RecognizeUnity({ data, close, sending, onForm }) {
  const handleRecognizeAll = useCallback(async () => {
    try {
      const {
        idalarmesistema,
        idalarmeconfig,
        idcliente,
        idposto,
        idusuario,
      } = data;

      await api.put(
        '/alarmessistemas/reconhece',
        assign(
          {
            idalarmesistema,
            idalarmeconfig,
            idcliente,
            idposto,
            idusuario,
          },
          {
            datahoraocorrenciatbalarmesistema: null,
            datahorareconhecimentotbalarmesistema: null,
            idusuarioreconhecimentoalarmesistema: null,
            datahoranormalizacaotbalarmesistema: null,
            origemalarmesistema: null,
            mensagemalarmesistema: null,
            tipocalculotbalarmesistema: null,
            valormomentotbalarmesistema: null,
            valorreferenciatbalarmesistema: null,
            chavealarmesistema: null,
            idusuarioreconhecimentosistema: null,
          }
        )
      );

      toast.success(t('s.geral.alertasistema.alarmereconhecido'));

      await onForm();
      await close();
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, [close, onForm]);

  useEffect(() => {
    if (sending) handleRecognizeAll();
  }, [sending]);

  return (
    <Typography>
      {t('s.geral.alertasistema.msgreconheceralarmeselecionado')}
    </Typography>
  );
}

RecognizeUnity.propTypes = {
  data: PropTypes.objectOf({
    idalarmesistema: PropTypes.number.isRequired,
    idalarmeconfig: PropTypes.number.isRequired,
    idcliente: PropTypes.number.isRequired,
    idposto: PropTypes.number.isRequired,
    idusuario: PropTypes.number.isRequired,
  }).isRequired,
  close: PropTypes.func.isRequired,
  sending: PropTypes.bool.isRequired,
  onForm: PropTypes.func.isRequired,
};
